/* <quick-stepper>: inline quick add on product cards.
   TMS buttons 2026-10-03 draft. Changes from the live file:
   1. The first tap adds to cart almost at once (350ms) instead of waiting 1.5s.
      Extra taps within 800ms are batched into one request.
   2. Clear states: a spinner while adding, a green tick for 2.5s after, a red state
      on failure. Screen readers hear "Added to cart" or the error.
   3. Failures are no longer silent: Shopify's own message (for example "All 3 are in
      your cart") is shown in a small toast.
   4. On phones, where the desktop peek cart does not show, a toast says
      "Added to cart" with a View cart link.
   Taps that arrive while a request is running are queued, not lost. */
(function () {
  var FIRST_DELAY = 350;
  var NEXT_DELAY = 800;
  var ADDED_MS = 2500;
  var ERROR_MS = 3500;

  function refreshCartBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.getElementById('cart-icon-bubble');
        if (!link) return;
        var count = cart.item_count;
        var bubble = link.querySelector('.cart-count-bubble');
        if (count > 0) {
          if (!bubble) {
            bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            link.appendChild(bubble);
          }
          bubble.innerHTML = '<span aria-hidden="true">' + count + '</span>';
        } else if (bubble) {
          bubble.remove();
        }
      })
      .catch(function () {});
  }

  /* One shared toast for all cards. role=status so it is announced. */
  var toast;
  var toastTimer;
  function showToast(message, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'tms-qs-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.classList.toggle('is-error', !!isError);
    toast.innerHTML = '';
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);
    if (!isError) {
      var link = document.createElement('a');
      link.href = (window.routes && window.routes.cart_url) || '/cart';
      link.textContent = 'View cart';
      toast.appendChild(link);
    }
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, isError ? ERROR_MS : 4000);
  }

  function isPhone() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  class QuickStepper extends HTMLElement {
    constructor() {
      super();
      this.count = 0;
      this.timer = null;
      this.busy = false;
      this.variantId = this.dataset.variantId;
      this.toggleBtn = this.querySelector('.quick-stepper__toggle');
      this.plusBtn = this.querySelector('.quick-stepper__plus');
      this.minusBtn = this.querySelector('.quick-stepper__minus');
      this.countEl = this.querySelector('.quick-stepper__count');
    }

    connectedCallback() {
      if (this.toggleBtn) this.toggleBtn.addEventListener('click', this.inc.bind(this));
      if (this.plusBtn) this.plusBtn.addEventListener('click', this.inc.bind(this));
      if (this.minusBtn) this.minusBtn.addEventListener('click', this.dec.bind(this));
      this.render();
    }

    inc(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var wasIdle = this.count === 0;
      this.count += 1;
      this.classList.remove('is-added', 'is-error');
      this.render();
      this.schedule(wasIdle ? FIRST_DELAY : NEXT_DELAY);
    }

    dec(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (this.count > 0) this.count -= 1;
      this.render();
      this.schedule(NEXT_DELAY);
    }

    render() {
      if (this.countEl) this.countEl.textContent = this.count;
      this.classList.toggle('is-active', this.count > 0);
      this.classList.toggle('is-one', this.count === 1);
      if (this.minusBtn) this.minusBtn.disabled = this.count === 0;
    }

    schedule(delay) {
      clearTimeout(this.timer);
      if (this.count > 0 && !this.busy) {
        this.timer = setTimeout(this.commit.bind(this), delay);
      }
    }

    finish(state) {
      var self = this;
      this.busy = false;
      this.classList.remove('is-loading');
      this.removeAttribute('aria-busy');
      this.classList.add(state);
      setTimeout(function () { self.classList.remove(state); }, state === 'is-added' ? ADDED_MS : ERROR_MS);
      // Taps made while the request was running are added next.
      if (this.count > 0) this.schedule(NEXT_DELAY);
    }

    commit() {
      var qty = this.count;
      if (qty <= 0 || !this.variantId || this.busy) return;
      var self = this;
      this.busy = true;
      this.count = 0;
      this.render();
      this.classList.add('is-loading');
      this.setAttribute('aria-busy', 'true');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(this.variantId), quantity: qty })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Could not add this item. Please try again.';
            self.finish('is-error');
            showToast(msg, true);
            return;
          }
          if (window.TMSCart) {
            var card = self.closest('.card-wrapper') || self.closest('.card');
            var img = card && card.querySelector('.card__media img, img');
            window.TMSCart.flyToCart(img);
            window.TMSCart.refresh({ peek: true });
          } else {
            refreshCartBubble();
          }
          self.finish('is-added');
          var name = (res.data && res.data.product_title) || 'Item';
          if (isPhone()) {
            showToast(qty > 1 ? name + ' x' + qty + ' added to cart' : name + ' added to cart', false);
          }
        })
        .catch(function () {
          self.finish('is-error');
          showToast('No connection. Please try again.', true);
        });
    }
  }

  if (!customElements.get('quick-stepper')) {
    customElements.define('quick-stepper', QuickStepper);
  }
})();
